import React from 'react'
import styled from 'react-emotion'
import HalfSizeImage from './HalfSizeImage'
import { Row } from './Grid'
import { H4 } from './Style'

export default ({
  clientLogo,
  features,
  platforms,
  technologies,
  team,
  projectLength,
  releaseDate,
}) => {
  return (
    <Row scrollable className="smaller">
      <ShortList>
        <HalfSizeImage path={clientLogo.replace('/assets/images/', '')} />
      </ShortList>

      <ShortList>
        <H4>Features</H4>
        <ul>{features.map(i => <li key={i}>{i}</li>)}</ul>
      </ShortList>

      <ShortList>
        <H4>Platform</H4>
        <ul>{platforms.map(i => <li key={i}>{i}</li>)}</ul>
      </ShortList>

      <ShortList>
        <H4>Technologies</H4>
        <ul>{technologies.map(i => <li key={i}>{i}</li>)}</ul>
      </ShortList>

      <ShortList>
        <H4>Scope</H4>
        {team.length} people<br />
        {projectLength}
      </ShortList>

      <ShortList>
        <H4>Release</H4>
        {releaseDate}
      </ShortList>
    </Row>
  )
}

const ShortList = styled.div`
  display: inline-block;
  vertical-align: top;
  padding-right: 30px;
`
